<style scoped>

</style>

<template>
  <component style="text-align: center" :is="componentName" :orderId="id" :payMethod="apply.payMethod" :applyResult="apply.result" />
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import FormPay from './FormPay'
import ScanPay from './ScanPay'
import JsApiPay from './JsApiPay'
import WapPay from './WapPay'
import { actionClient } from '@/api'
const { mapState } = createNamespacedHelpers('payApply')
import { isWechat } from '@/helpers'

import config from '@/config'

const OPENID_KEY = 'wechat_openid'




function getOpenid() {
  return localStorage.getItem(OPENID_KEY)
}

function setOpenid(openid) {
  localStorage.setItem(OPENID_KEY, openid)
}

function getQueryParam(name) {
  const match = new RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search)
  return match ? decodeURIComponent(match[1]) : ''
}

function redirectToWechatAuth() {
  const appId = config.wechat.appId
  const localDomain = window.location.href.replace(/^https?:\/\//, '')
  const redirectUri = encodeURIComponent(`https://m.casiostore.com.cn/oauthagent.php?target=${config.wechat.target}&localDomain=${localDomain}`)
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
}

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    FormPay,
    ScanPay,
    JsApiPay,
    WapPay
  },
  computed: {
    ...mapState([
      'apply'
    ]),
    componentName() {
      let name
      switch (this.apply.payMethod) {
        case 'wechat-scan':
          name = 'ScanPay'
          break
        case 'alipay-wap':
          name = 'FormPay'
          break
        case 'wechat-jsapi':
          name = 'JsApiPay'
          break
        case 'wechat-wap':
          name = 'WapPay'
          break
        default:
          name = 'span'
      }
      return name
    }
  },
  methods: {
    async payApply(id) {
      let isWechatEnv = isWechat()
      let openid = getOpenid()
      if (isWechatEnv && !openid) {
        const code = getQueryParam('code')
        if (code) {
          // 用授权 code 换取 openid
          const result = await actionClient.post('wechat/openid', { code })
          openid = result.openid
          setOpenid(openid)
          // 清除 URL 中的 code 参数，避免重复使用
          window.history.replaceState({}, '', window.location.pathname)
        } else {
          // 跳转微信网页授权
          redirectToWechatAuth()
          return
        }
      }

      this.$store.dispatch('payApply/apply', { orderId: id, isWechat: isWechatEnv, openid })
    }
  },
  mounted() {
    this.payApply(this.id)
  }
}
</script>
